import React from 'react';

import withAuthServerSideProps from '@/libs/auth';
import LiveVideoDetailLayout, {
  LiveVideoDetailLayoutProps,
} from '@/features/livestream/detail';

import { toInt } from '@/libs/app';
import { KeyActive, PageLayout, PagePath } from '@/layouts/shared';
import { getAuthServer } from '@/libs/cookies';
import { GetServerSidePropsContext } from 'next';
import {
  fetchCollectionSticker,
  fetchCommentById,
  fetchLiveVideo,
} from '@/features/livestream/detail/api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSelectorsByUserAgent } from 'react-device-detect';
import { fetchComments } from '@/features/livestream/detail/api';

const LiveVideoDetailPage = ({
  liveVideo,
  isAuth,
  collectionStickers,
  comments,
  offset,
}: LiveVideoDetailLayoutProps) => {
  return (
    <LiveVideoDetailLayout
      collectionStickers={
        collectionStickers.length > 0 ? collectionStickers : []
      }
      liveVideo={liveVideo}
      isAuth={isAuth}
      offset={offset}
      comments={comments}
    />
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async (context: GetServerSidePropsContext) => {
    try {
      const { locale, query, req } = context;
      const { id, comment_id } = query;
      let _id = id;
      let comments = [];
      const arrHandle = (id as string).split('-');
      const offset = 0;
      if ((arrHandle?.length as any) > 1) {
        _id = (arrHandle as any)[(arrHandle?.length as any) - 1];
      }
      const { isAuth } = getAuthServer(context);
      const { data: liveVideo } = await fetchLiveVideo(toInt(_id));
      if (comment_id) {
        const { data: _d } = await fetchCommentById(comment_id);
        if (typeof _d == 'object') comments = [_d];
        else comments = _d;
      } else {
        const { data: _d } = await fetchComments({ id: _id, offset: 0 });
        comments = _d;
      }
      const { data: collectionStickers } = await fetchCollectionSticker({
        live_stream_id: toInt(_id),
      });
      const { isMobile } = getSelectorsByUserAgent(
        req.headers['user-agent'] as string
      );
      return {
        props: {
          liveVideo,
          isAuth,
          collectionStickers,
          isMobile,
          offset,
          comments: isAuth ? comments : [],
          layout: PageLayout.New,
          keyActive: KeyActive.LiveVideo,
          ...(await serverSideTranslations(locale as string, [
            'live-video',
            'layout',
          ])),
        },
      };
    } catch (_) {
      return {
        redirect: {
          permanent: false,
          destination: PagePath.DashboardPage,
        },
      };
    }
  },
  { isAntiAuth: false, isPublic: true }
);

export default LiveVideoDetailPage;
